export const browserZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
export function eventDate(value: string, timeZone = browserZone()) {
  return new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone,
  }).format(new Date(value));
}
export function localInput(value: string, timeZone: string) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(new Date(value));
  const p = Object.fromEntries(parts.map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}
export function instantFromLocal(value: string, timeZone: string) {
  const match = /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)$/.exec(value);
  if (!match) throw new Error("Preencha a data e o horário.");
  const [, y, m, d, h, min] = match;
  const utc = Date.UTC(Number(y), Number(m) - 1, Number(d), Number(h), Number(min));
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  });
  const found: string[] = [];
  for (let offset = -14 * 60; offset <= 14 * 60; offset += 15) {
    const instant = new Date(utc + offset * 60000);
    const p = Object.fromEntries(formatter.formatToParts(instant).map((x) => [x.type, x.value]));
    if (`${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}` === value)
      found.push(instant.toISOString());
  }
  if (found.length !== 1)
    throw new Error(
      found.length
        ? "Esse horário ocorre duas vezes nesse fuso. Escolha um horário sem ambiguidade."
        : "Esse horário não existe nesse fuso. Confira a mudança de horário local.",
    );
  return found[0]!;
}
export function eventsSearch(search: Record<string, unknown>) {
  const month =
    typeof search.month === "string" && /^\d{4}-(0[1-9]|1[0-2])$/.test(search.month)
      ? search.month
      : undefined;
  return {
    month,
    period:
      search.period === "today" || search.period === "week" || search.period === "month"
        ? search.period
        : month
          ? "month"
          : "week",
    kind: search.kind === "online" || search.kind === "in_person" ? search.kind : "all",
    view: search.view === "list" ? "list" : "calendar",
    day: validDay(search.day),
    date: validDay(search.date),
    page: Math.max(1, Number.isSafeInteger(Number(search.page)) ? Number(search.page) : 1),
  };
}
function validDay(value: unknown) {
  if (typeof value !== "string" || !/^\d{4}-\d\d-\d\d$/.test(value)) return undefined;
  const date = new Date(`${value}T12:00:00`);
  return Number.isFinite(+date) && dateKey(date) === value ? value : undefined;
}
export function dateKey(date: Date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}
export function calendarRange(month: string | undefined, period: string, now = new Date()) {
  const start =
    period === "month"
      ? new Date(`${month ?? dateKey(now).slice(0, 7)}-01T00:00:00`)
      : new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (period === "week") start.setDate(start.getDate() - ((start.getDay() + 6) % 7));
  const end = new Date(start);
  if (period === "month") end.setMonth(end.getMonth() + 1);
  else end.setDate(end.getDate() + (period === "week" ? 7 : 1));
  return {
    from: start.toISOString(),
    to: end.toISOString(),
    month: new Date(start.getFullYear(), start.getMonth(), 1),
  };
}
